import { render, staticRenderFns } from "./SendLeadsToDeliveryCampaignModal.vue?vue&type=template&id=57db4b93"
import script from "./SendLeadsToDeliveryCampaignModal.vue?vue&type=script&lang=js"
export * from "./SendLeadsToDeliveryCampaignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports